var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-icon',{staticClass:"pencil-hover",attrs:{"small":"","color":_vm.color ? _vm.color : 'grey'}},[_vm._v(" mdi-pencil ")])}
var staticRenderFns = []

export { render, staticRenderFns }